import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  title: 'Edit video',
  back: 'Back',
  tipHeader: 'Instructions',
  tip1: 'The <strong>"Add video"</strong> button lets you pick media from your library or generate AI images and clips.',
  tip2: '<strong>Edit the script</strong> to change the audio connected your chosen segment. You can adjust the content, language and narration settings.',
  tip3: '<strong>Regenerate</strong> reprocesses only the selected clip based on its linked page.',
  tip4: '<strong>Mute audio</strong> hides the sound for that segment.',
  editVideoOptions_EditScript: 'Edit script',
  editVideoOptions_MuteAudio: 'Mute audio',
  editVideoOptions_Regenerate: 'Regenerate',
  editVideoOptions_ChangeMedia: 'Replace with Storyblocks',
  editVideoOptions_ChangeMediaLibrary: 'Replace with media library',
  editVideoOptions_ReplaceAIMedia: 'Replace AI-generated media',
  editVideoOptions_EditMedia: 'Edit media',
  editVideoOptions_Delete: 'Delete',
  editMediaModalTitle: 'Replace media',
  editMediaClipSlots: 'Clip slots',
  editMediaClipPreview: 'Clip preview',
  editMediaSelectMedia: 'Select media',
  editMediaAddSlot: '+ Add extra media',
  editMediaSecondsLeft: 'seconds left',
  editMediaBadgeNew: 'New',
  editMediaBadgeReplaced: 'Replaced',
  editMediaBadgeEdited: 'Edited',
  editMediaBadgeDeleted: 'Deleted',
  editMediaBadgeReordered: 'Reordered',
  editMediaReorder: 'Drag to reorder',
  editMediaTotalLabel: 'Total',
  editMediaLocked:
    'This clip is generated from the source slide. To change it use “Replace everything”.',
  editMediaWarnOver: 'Clips exceed segment duration by',
  editMediaWarnUnder: 'Clips shorter than segment by',
  editMediaNoMediaHint: 'No media selected',
  editMediaEmptyChunkHint:
    'This scene has no separate clips yet. Pick media from the library to fill it.',
  editMediaApply: 'Apply',
  editMediaSaveAll: 'Save all changes',
  editMediaReplaceAll: 'Replace everything',
  editMediaCancelReplaceAll: 'Cancel replace',
  editMediaReplaceAllHint:
    'Replace everything mode is on. Press “Cancel replace” to exit.',
  editMediaTrimLabel: 'Trim',
  editMediaReplaceAllSave: 'Replace all media',
  editMediaRevert: 'Revert',
  editMediaDelete: 'Remove',
  editMediaTabLibrary: 'Library',
  editMediaTabStoryblocks: 'StoryBlocks',
  editMediaFilterAll: 'All',
  editMediaFilterAiVideo: 'AI videos',
  editMediaPreviewEmpty: 'Nothing to preview',
  editMediaSaveQueued: 'Changes saved',
  editMediaSaveError: 'Failed to update artifacts',
  scopeEditing: 'Editing microreel:',
  scopeHint: 'Only the clips that belong to this microreel can be edited.',
  editVideoOptions_EditNarration: 'Edit narration',
  editVideoOptions_ConfirmDelete: 'Are you sure you want to delete this clip?',
  editVideoOptions_Disabled: 'Editing disabled for this clip',
  editNarrationModalTitle: 'Edit narration',
  editNarrationModalSave: 'Save',
  editNarrationSuccess: 'Narration updated successfully',
  emptyChunkPreview: 'No clip selected for preview',
  stateRegenerating: 'Saving video',
  stateChangingMedia: 'Changing media',
  stateMutingAudio: 'Muting audio',
  stateReplacingWithLibrary: 'Replacing with Media library',
  stateReplacingAIMedia: 'Replacing AI-generated media',
  stateChangingNarration: 'Updating narration',
  stateWorking: 'Working...',
  replaceAIMediaModalTitle: 'Replace AI-generated media',
  replaceAIMediaReplace: 'Replace',
  replaceAIMediaChange: 'Change',
  replaceAIMediaRemove: 'Remove',
  replaceAIMediaSave: 'Save',
  replaceAIMediaNoArtifacts: 'No media available for this clip',
  replaceAIMediaSuccess: 'AI media replacement started',
  replaceAIMediaOnlyOneVideo:
    'Only one video replacement is supported per operation',
  stateDisablingBackgroundAudio: 'Removing background music',
  removeBackgroundMusic: 'Remove background music',
  confirmRemoveBackgroundMusic:
    'This will permanently remove the background music from the video, once the changes are saved.',
  confirmRemoveBackgroundMusicAccept: 'Yes, remove',
  addMedia: 'Add media',
  addMediaFromLibrary: 'Add from library',
  addMediaFromStoryblocks: 'Add from Storyblocks',
  addMediaRemoveAudio: 'Remove audio',
  addMediaPending:
    'Adding media is taking longer than expected. Please check the timeline in a minute.',
  addMediaWait: 'Please wait until the current processing finishes.',
  editNarrationLoadFailed: 'Failed to load narration text',
};

const welsh = {
  title: 'Golygu Ffynhonnell y Fideo',
  back: 'Yn ôl',
  tipHeader: 'Cyfarwyddiadau',
  tip1: 'Mae\'r botwm <strong>"Ychwanegu fideo"</strong> yn eich galluogi i ddewis cyfryngau o\'ch llyfrgell neu gynhyrchu delweddau a clipiau AI.',
  tip2: "<strong>Golygu'r sgript</strong> i newid y sain sy'n gysylltiedig â'r segment a ddewiswyd. Gallwch addasu'r cynnwys, y iaith a'r gosodiadau darllen.",
  tip3: '<strong>Ailgynhyrchu</strong> yn ailbrosesu dim ond y clip a ddewiswyd yn seiliedig ar ei dudalen gysylltiedig.',
  tip4: "<strong>Mute audio</strong> yn cuddio'r sain ar gyfer y segment hwnnw.",
  editVideoOptions_EditScript: 'Golygu sgript',
  editVideoOptions_MuteAudio: 'Mute audio',
  editVideoOptions_Regenerate: 'Ailgynhyrchu',
  editVideoOptions_ChangeMedia: 'Newid cyfryngau',
  editVideoOptions_ChangeMediaLibrary: 'Newid cyfryngau',
  editVideoOptions_ReplaceAIMedia: 'Disodli cyfryngau AI',
  editVideoOptions_EditMedia: 'Golygu cyfryngau',
  editVideoOptions_Delete: 'Dileu',
  editMediaModalTitle: 'Disodli cyfryngau',
  editMediaClipSlots: 'Slotiau clipiau',
  editMediaClipPreview: 'Rhagolwg clip',
  editMediaSelectMedia: 'Dewis cyfryngau',
  editMediaAddSlot: '+ Ychwanegu cyfryngau arall',
  editMediaSecondsLeft: 'eiliad ar ôl',
  editMediaBadgeNew: 'Newydd',
  editMediaBadgeReplaced: 'Disodli',
  editMediaBadgeEdited: 'Golygu',
  editMediaBadgeDeleted: 'Dileu',
  editMediaBadgeReordered: 'Wedi’i aildrefnu',
  editMediaReorder: 'Llusgo i aildrefnu',
  editMediaTotalLabel: 'Cyfanswm',
  editMediaLocked:
    'Mae’r clip hwn wedi’i greu o’r sleid ffynhonnell. I’w newid, defnyddiwch “Disodli popeth”.',
  editMediaWarnOver: 'Clipiau yn fwy na hyd y segment o',
  editMediaWarnUnder: 'Clipiau yn fyrrach na hyd y segment o',
  editMediaNoMediaHint: 'Dim cyfryngau wedi’u dewis',
  editMediaEmptyChunkHint:
    'Nid oes clipiau ar wahân yn y golygfa hon eto. Dewiswch gyfryngau o’r llyfrgell i’w llenwi.',
  editMediaApply: 'Cymhwyso',
  editMediaSaveAll: 'Cadw pob newid',
  editMediaReplaceAll: 'Disodli popeth',
  editMediaCancelReplaceAll: 'Canslo disodli',
  editMediaReplaceAllHint:
    'Mae’r modd Disodli popeth ymlaen. Pwyswch “Canslo disodli” i ddod allan.',
  editMediaTrimLabel: 'Tociad',
  editMediaReplaceAllSave: 'Disodli pob cyfrwng',
  editMediaRevert: 'Dadwneud',
  editMediaDelete: 'Tynnu',
  editMediaTabLibrary: 'Llyfrgell',
  editMediaTabStoryblocks: 'StoryBlocks',
  editMediaFilterAll: 'Pob un',
  editMediaFilterAiVideo: 'Fideos AI',
  editMediaPreviewEmpty: "Dim i'w ragweld",
  editMediaSaveQueued: "Newidiadau wedi'u cadw",
  editMediaSaveError: "Methwyd diweddaru'r artiffactau",
  scopeEditing: "Wrthi'n golygu microreel:",
  scopeHint:
    "Dim ond y clipiau sy'n perthyn i'r microreel hwn y gellir eu golygu.",
  editVideoOptions_EditNarration: 'Golygu adroddiad',
  editVideoOptions_ConfirmDelete: "Ydych chi wir eisiau dileu'r clip hwn?",
  editVideoOptions_Disabled: 'Mae golygu wedi’i analluogi ar gyfer y clip hwn',
  editNarrationModalTitle: 'Golygu adroddiad',
  editNarrationModalSave: 'Cadw',
  editNarrationSuccess: "Adroddiad wedi'i ddiweddaru'n llwyddiannus",
  emptyChunkPreview: "Dim darn wedi'i ddewis ar gyfer rhagolwg",
  stateRegenerating: 'Ail-greu fideo',
  stateChangingMedia: 'Newid cyfryngau',
  stateMutingAudio: 'Tawelu sain',
  stateReplacingWithLibrary: 'Yn disodli gyda chyfrwng y llyfrgell',
  stateReplacingAIMedia: 'Yn disodli cyfryngau AI',
  stateChangingNarration: 'Diweddaru adroddiad',
  stateWorking: 'Gweithio...',
  replaceAIMediaModalTitle: 'Disodli cyfryngau AI',
  replaceAIMediaReplace: 'Disodli',
  replaceAIMediaChange: 'Newid',
  replaceAIMediaRemove: 'Tynnu',
  replaceAIMediaSave: 'Cadw',
  replaceAIMediaNoArtifacts: 'Dim cyfryngau ar gael ar gyfer y clip hwn',
  replaceAIMediaSuccess: 'Disodli cyfryngau AI wedi dechrau',
  replaceAIMediaOnlyOneVideo:
    "Dim ond un amnewid fideo sy'n cael ei gefnogi fesul gweithrediad",
  stateDisablingBackgroundAudio: 'Removing background music',
  removeBackgroundMusic: 'Remove background music',
  confirmRemoveBackgroundMusic:
    'This will permanently remove the background music from the video, once the changes are saved.',
  confirmRemoveBackgroundMusicAccept: 'Yes, remove',
  addMedia: 'Ychwanegu cyfryngau',
  addMediaFromLibrary: "Ychwanegu o'r Llyfrgell",
  addMediaFromStoryblocks: 'Ychwanegu o Storyblocks',
  addMediaRemoveAudio: 'Tynnwch sain',
  addMediaPending:
    'Mae ychwanegu cyfryngau yn cymryd mwy o amser nag arfer. Gwiriwch y llinell amser mewn munud.',
  addMediaWait: 'Arhoswch nes bod y prosesu presennol wedi gorffen.',
  editNarrationLoadFailed: 'Methwyd â llwytho testun yr adroddiad',
};

export const VideoEditorText: any = getLocalizationBasedOnLang(english, welsh);
